import { useRef } from 'react';
import { ga } from '@/lib/analytics';

export const useGAMouseOver = () => {
  const isMouseOverRef = useRef<boolean>(false);

  const sendGAEvent = ({
    section,
    component,
    gameId,
    gameName,
    status,
  }: {
    section: string;
    component: string;
    gameId?: string;
    gameName?: string;
    status?: string;
  }) => {
    ga.trackMouseOver({
      component,
      section,
      ...(gameId && { game_id: gameId }),
      ...(gameName && { game_name: gameName }),
      ...(status && { status: status }),
    });
  };

  const handleMouseEnter = (props: {
    section: string;
    component: string;
    gameId?: string;
    gameName?: string;
    status?: string;
  }) => {
    if (isMouseOverRef.current) {
      return;
    }
    isMouseOverRef.current = true;
    sendGAEvent(props);
  };

  const handleMouseLeave = () => {
    isMouseOverRef.current = false;
  };

  return {
    handleMouseEnter,
    handleMouseLeave,
  };
};
